import Swiper from 'swiper'
import { EffectFade, Keyboard, Navigation, Pagination } from 'swiper/modules'
import { destroySwiper } from '../utils/dom'

let exclusiveUseSwipers = []
let exclusiveUseController = null

function formatNumber(number) {
	return ('0' + number).slice(-2)
}

function createSwiper(container, options) {
	if (!container || !container.querySelector('.swiper-slide')) {
		return null
	}

	destroySwiper(container)

	const instance = new Swiper(container, options)
	exclusiveUseSwipers.push(instance)

	return instance
}

function activateDesktopImage(container, key) {
	const images = container.querySelectorAll('.exclusive-use__image')

	images.forEach((image) => {
		image.classList.toggle('active', image.dataset.image === key)
	})
}

export default function initExclusiveUse() {
	exclusiveUseSwipers.forEach((swiperInstance) => {
		if (!swiperInstance.destroyed) {
			swiperInstance.destroy(true, true)
		}
	})
	exclusiveUseSwipers = []

	exclusiveUseController?.abort()
	exclusiveUseController = new AbortController()
	const { signal } = exclusiveUseController

	document.querySelectorAll('.exclusive-use--mobile').forEach((container) => {
		const contentCarousel = container.querySelector('.exclusive-use__content-carousel')
		const backgroundCarousel = container.querySelector('.exclusive-use__background')

		const contentSwiper = createSwiper(contentCarousel, {
			modules: [Keyboard, Navigation, Pagination],
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			slidesPerView: 1,
			speed: 600,
			navigation: {
				nextEl: container.querySelector('.exclusive-use__next'),
				prevEl: container.querySelector('.exclusive-use__prev'),
			},
			pagination: {
				el: container.querySelector('.exclusive-use__pagination'),
				type: 'fraction',
				formatFractionCurrent: formatNumber,
				formatFractionTotal: formatNumber,
			},
		})

		const backgroundSwiper = createSwiper(backgroundCarousel, {
			modules: [EffectFade],
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 600,
		})

		if (contentSwiper && backgroundSwiper) {
			contentSwiper.on('slideChange', () => {
				backgroundSwiper.slideTo(contentSwiper.activeIndex, 600)
			})
		}
	})

	document.querySelectorAll('.exclusive-use--desktop').forEach((container) => {
		const links = container.querySelectorAll('.exclusive-use__link')

		links.forEach((link) => {
			const key = link.dataset.image

			if (!key) return

			link.addEventListener('mouseenter', () => activateDesktopImage(container, key), { signal })
			link.addEventListener('focus', () => activateDesktopImage(container, key), { signal })
		})
	})
}
